export const ChatWidget = () => {

  if (window.Genesys === undefined) {
    return;
  }

  window.Genesys('unsubscribe', 'Launcher.ready');

  window.Genesys('subscribe', 'Launcher.ready', () => {
    const launcher = document.getElementById('genesys-messenger');

    const allowedPathsToShow = [
      '/account/make-a-change/personal-details/:uuid',
      '/account/make-a-change/mta/additional-cover',
      '/account/make-a-change/mta/additional-travellers',
      '/account/make-a-change/mta/medical-declaration',
      '/account/make-a-change/mta/change-region',
      '/account/make-a-change/mta/change-trip-date',
      '/account/make-a-change/mta/change-tier',
      '/account/make-a-change/mta/change-trip-duration',
    ]

    function matchPath(pathName: string, allowedPaths: string[]) {
      return allowedPaths.some(allowedPath => {
        // Convert the allowed path pattern into a regex
        const regexPattern = allowedPath
          .replace(/:uuid/g, '[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}')  // Replace ":uuid" with a UUID regex pattern
          .replace(/\//g, '\\/');

        const regex = new RegExp(`^${regexPattern}$`);
        return regex.test(pathName);
      });
    }

    const shouldLoad = matchPath(location.pathname, allowedPathsToShow);
    shouldLoad ? launcher.style.display = 'block' : launcher.style.display = 'none';
  });

}
